import { USER_ROLES, userHasRole, type AppUser } from '@/lib/auth';
import { createUnauthorizedError } from '@/lib/services/errors';

export type AdminOrManager = AppUser & {
  role: typeof USER_ROLES.administrator | typeof USER_ROLES.manager;
};

export function isAdminOrManager(user: AppUser | null | undefined): user is AdminOrManager {
  return userHasRole(user, USER_ROLES.administrator, USER_ROLES.manager);
}

export function requireUser(user: AppUser | null | undefined): AppUser {
  if (!user) {
    throw createUnauthorizedError('User session required.');
  }
  return user;
}

export function requireAdminOrManager(user: AppUser | null | undefined): AdminOrManager {
  const resolved = requireUser(user);
  if (!isAdminOrManager(resolved)) {
    throw createUnauthorizedError('Administrator or manager role required.');
  }
  return resolved;
}
